
define('ldsh!modules/editor/templates/new_popup_modal', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="ed-opt-toolbar ed-modal-header">\n    <h3 data-i18n="editor.popup.new" class="ed-modal-title"></h3>\n  </div>\n\n  <div class="ed-opt-content ed-modal-content">\n    <p data-i18n="editor.popup.presentation"></p>\n    <p class="mt30 mb40" data-i18n="[html]editor.popup.description"></p>\n  </div>\n\n  <div class="ed-opt-btnbar ed-modal-footer">\n    <button\n      data-i18n="editor.popup.ok"\n      type="button"\n      class="ed-btn ed-btn-primary-action js-continue"\n    ></button>\n  </div>\n\n</div>\n';

}
return __p
};});

